import { render } from "./QwIcon.vue?vue&type=template&id=04cb23fd"
import script from "./QwIcon.vue?vue&type=script&lang=js"
export * from "./QwIcon.vue?vue&type=script&lang=js"

import "./QwIcon.vue?vue&type=style&index=0&id=04cb23fd&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__